module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/pdf-42963f45ac1beb7ea8b97457e910dd25.svg";